"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var utils_1 = require("../../../utils");
var Card_1 = require("../../Card");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Tabs_1 = require("../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../TextArea"));
var CommentsForm = function (_a) {
    var tabId = _a.tabId;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, ['comments'])); }, [errors]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.comments') },
        react_1.default.createElement(FormControl_1.default, { errors: errors.comments, dusk: "comments-field", label: trans('optiiva::labels.comments'), expand: true, flush: true },
            react_1.default.createElement(TextArea_1.default, { name: "comments" }))));
};
exports.default = CommentsForm;
//# sourceMappingURL=CommentsForm.js.map